const pathList = () => import('@/pages/path/index.vue');
const pathForm = () => import('@/pages/path/form.vue');

export default [{
    path: '/path/list',
    component: pathList,
    meta: [{
        name: '路径配置'
    },
    {
        name: '路径配置列表',
        activeRoute: '/path/list'
    }]
}, {
    path: '/path/form',
    component: pathForm,
    meta: [{
        name: '路径配置'
    },
    {
        name: '路径配置列表',
        url: '/path/list',
    },
    {
        name: '添加/编辑',
        activeRoute: '/path/list'
    }]
}];